// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SubjectChoice/Confirm.less
// module id = 1642
// module chunks = 0